// TODO: use the CDN version when it becomes available
const DEFAULT_FALLBACK_IMAGE_PATH = '/img/fallback-image.jpg';

export const renderImageOrFallback = (url: string, fallback: string = DEFAULT_FALLBACK_IMAGE_PATH) => {
  return url || fallback;
};
